import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ProductComponent from '../components/Product/Product';
import * as productActions from '../actions/Products';
import {hideModal} from '../actions/Modal';
class Product extends Component {
    
    onSearchInputKeyPressed = (e) => {
        if(e.key == 'Enter'){
            this.props.searchProductsByText(this.props.product.textForSearching);
        }
    }

    onSearchInputTextChanged = (e) => this.props.updateTextForSearching(e.target.value);

    onSearchButtonClicked = () => this.props.searchProductsByText(this.props.product.textForSearching);

    onTablePageChange = (page) => this.props.changeTablePage(page);

    onSelectedTableRowChange = (row) => this.props.changeSelectedRow(row);

    onSaveButtonClick = () => this.props.onConfirmDialogClick(this.props.product.selectedRow);

    onDismissButtonClick = () => this.props.dismissChanges();
    
    render(){
        return(
            <ProductComponent
                onSearchInputKeyPressed={this.onSearchInputKeyPressed}
                onSearchInputTextChanged={this.onSearchInputTextChanged}
                onSearchButtonClicked={this.onSearchButtonClicked}
                product={this.props.product}
                onTablePageChange={this.onTablePageChange}
                onSelectedTableRowChange={this.onSelectedTableRowChange}
                onSaveButtonClick={this.onSaveButtonClick}
                onDismissButtonClick={this.onDismissButtonClick}/>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        product: state.product
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        searchProductsByText: (text) => dispatch(productActions.searchProductsByText(text)),
        updateTextForSearching: (text) => dispatch(productActions.ChangeTextForSearching(text)),
        changeTablePage: (page) => dispatch(productActions.ChangeTablePage(page)),
        changeSelectedRow: (selectedRow) => dispatch(productActions.ChangeSelectedRow(selectedRow)),
        onConfirmDialogClick: (selectedRow) => dispatch(productActions.ConfirmModal(selectedRow)),
        dismissChanges: () => dispatch(hideModal())
    };
};

Product.propTypes = {
    changeSelectedRow: PropTypes.func,
    changeTablePage: PropTypes.func,
    dismissChanges: PropTypes.func,
    onConfirmDialogClick: PropTypes.func,
    product: PropTypes.shape({
        products: PropTypes.array,
        selectedRow: PropTypes.object,
        tablePage: PropTypes.number,
        textForSearching: PropTypes.string
    }),
    updateTextForSearching: PropTypes.func,
    searchProductsByText : PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(Product);


// WEBPACK FOOTER //
// ./src/containers/Product.js